import React from 'react';
import {withTranslation} from 'react-i18next';

const OpenCloseWysiwigContent = ({descriptionShort, description, t, title, openCta = null, closeCta = null}) => {
    const [open, setOpen] = React.useState(false);

    const handleChange = () => {
        setOpen(!open);
    };

    if (!descriptionShort && !description) {
        return null;
    }
    if (!descriptionShort && description) {
        return  <>
            {title && <label><strong>{title}</strong></label>}
            <p className="wysiwyg" dangerouslySetInnerHTML={{__html: description}}/>
        </>;
    }

    if (descriptionShort) {
        return (<>
            {title && <label><strong>{title}</strong></label>}

            {descriptionShort && <>
                {!open && <>
                    <p className="description-short wysiwyg"
                       onClick={() => handleChange()}
                       dangerouslySetInnerHTML={{__html: descriptionShort}}/>
                    {description && <span className="openclose-cta" onClick={() => handleChange()}>{openCta ? openCta : t('Omegaroc.collapse.open')}</span>}
                </>}

                {description && open && <>
                    <p className="wysiwyg" dangerouslySetInnerHTML={{__html: description}} onClick={() => handleChange()}/>
                    <span className="openclose-cta" onClick={() => handleChange()}>{closeCta ? closeCta : t('Omegaroc.collapse.close')}</span>
                </>}
            </>}
        </>)
    }
}

export default withTranslation()(OpenCloseWysiwigContent);